import CloseHeader from '@/common/components/layouts/CloseHeader';
import NavigationBar from '@/common/components/layouts/NavigationBar.tsx';
import OnlyBackHeader from '@/common/components/layouts/OnlyBackHeader.tsx';
import OnlyTitleHeader from '@/common/components/layouts/OnlyTitleHeader';
import SliderHeader from '@/common/components/layouts/SliderHeader.tsx';
import TitleHeader from '@/common/components/layouts/TitleHeader.tsx';
import {
  BackwardHandlerType,
  MainLayoutProps,
  RenderHeadersProps,
} from '@/common/types/LayoutTypes.ts';
import { AnimatePresence, motion } from 'framer-motion';
import { FC } from 'react';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

const MainLayout: FC<MainLayoutProps & BackwardHandlerType> = ({
  header,
  navbar,
  fullWidth = false,
  title,
  children,
  hasBottomPadding,
  backwardHandler,
}) => {
  const navigationBars = navbar ? <NavigationBar /> : <></>;
  const renderHeaders: FC<RenderHeadersProps> = ({
    header: headerType = 'none',
    title: headerTitle,
  }) => {
    const headers = {
      onlyTitleHeader: <OnlyTitleHeader title={headerTitle!} />,
      titleHeader: (
        <TitleHeader title={headerTitle!} backwardHandler={backwardHandler} />
      ),
      sliderHeader: <SliderHeader />,
      onlyBackHeader: <OnlyBackHeader />,
      closeHeader: <CloseHeader title={headerTitle!} />,
      none: <></>,
    };

    return headers[headerType];
  };
  const paddingBottom = navbar || hasBottomPadding ? '24' : 'initial';
  const headerMarginTop = [
    'titleHeader',
    'onlyTitleHeader',
    'sliderHeader',
    'closeHeader',
  ];
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Box zIndex="layout" pos="fixed" top={0} w="[100%]">
          {renderHeaders({ header, title })}
        </Box>
        <Box
          width={fullWidth ? '100%' : '90%'}
          paddingBottom={paddingBottom}
          maxWidth="maxContainer"
          margin="auto"
          className={css({
            marginTop:
              header && headerMarginTop.includes(header) ? '66px' : '30px',
          })}
        >
          {children}
        </Box>
        {navigationBars}
      </motion.div>
    </AnimatePresence>
  );
};

export default MainLayout;
